import { useEffect, useState } from 'react';
import { useLocale } from '../special/LanguageProvider';
import { apiCall } from '../special/apiCall';

const SHARED_URL = process.env.REACT_APP_SHARED_API_URL ? process.env.REACT_APP_SHARED_API_URL.replace(/\/$/, '') : '';

export default source => {
  const [loadedIS, setLoadedIS] = useState(false);
  const [loadedEN, setLoadedEN] = useState(false);
  const { updateLocaleForLang } = useLocale();

  const loadIS = async () =>{
    const [common, trans] = await Promise.all([
      apiCall(`${SHARED_URL}/translation/getTranslationDocument/2009/1`),
      apiCall(`${SHARED_URL}/translation/getTranslationDocument/${source}/1`)
    ]);
    if ((common.error) || (trans.error))
    {
      console.log("Language error loading IS", source, common.error, trans.error);
    }
    else
    {
      updateLocaleForLang('is', { ...common, ...trans });
      setLoadedIS(true);    
    }
  };

  const loadEN = async () =>{
    const [common, trans] = await Promise.all([
      apiCall(`${SHARED_URL}/translation/getTranslationDocument/2009/2`),
      apiCall(`${SHARED_URL}/translation/getTranslationDocument/${source}/2`)
    ]);
    if ((common.error) || (trans.error))
    {
      console.log("Language error loading EN", source, common.error, trans.error);
    }
    else
    {
      updateLocaleForLang('en', { ...common, ...trans });
      setLoadedEN(true);    
    }
  };

  useEffect(() => {
    if (source) {
      //Load translation for IS
      loadIS();
      loadEN();
    }
  }, []);

  return loadedIS && loadedEN;
};

